// import React, { useState, useEffect } from "react";
// import { Modal, Button, Form, Card, Table } from "react-bootstrap";

// const ScoreTable = ({isProfile = false }) => {
//   const getStoredData = () => {
//     const storedData = localStorage.getItem("mockScoreTableData");
//     return storedData
//       ? JSON.parse(storedData)
//       : [
//           { id: 1, date: "2024-02-20", test: "Math", score: 85, goal: 90 },
//           { id: 2, date: "2024-02-21", test: "Science", score: 78, goal: 85 },
//         ];
//   };

//   const [data, setData] = useState(getStoredData);
//   const [showModal, setShowModal] = useState(false);
//   const [modalType, setModalType] = useState("add");
//   const [formData, setFormData] = useState({
//     id: null,
//     studentId: slug,
//     assdate: "",
//     coursetest: "",
//     score: "",
//     goal: "",
//     grade: null,
//     type: COURSE_TYPES.sat,
//   });

//     async function GetData() {
//       getDataWithType("sat").then(setData);
//     }
  
//     useEffect(() => {
//       GetData();
//     }, [slug]);

//   // Veri sıralama ve gruplama fonksiyonu
//   const groupedData = () => {
//     // Veriyi tarihe göre sıralıyoruz
//     const sortedData = [...data]
//     .filter(row => row.studentId === slug)
//     .sort(
//       (a, b) => new Date(a.assdate) - new Date(b.assdate)
//     );

//     // Aynı tarihe sahip verileri grupla
//     const groups = [];
//     let currentDate = null;
//     let currentGroup = [];

//     sortedData.forEach((row) => {
//       if (row.assdate !== currentDate) {
//         if (currentGroup.length > 0) {
//           groups.push(currentGroup);
//         }
//         currentDate = row.assdate;
//         currentGroup = [row];
//       } else {
//         currentGroup.push(row);
//       }
//     });

//     if (currentGroup.length > 0) {
//       groups.push(currentGroup);
//     }

//     // Grupların altında toplamları hesapla
//     const groupedWithTotals = groups.map((group) => {
//       const totalScore = group.reduce((acc, row) => acc + row.score, 0);
//       const totalGoal = group.reduce((acc, row) => acc + row.goal, 0);

//       return {
//         date: group[0].assdate, // Tüm grup aynı tarihe ait olacak
//         rows: group,
//         totalScore,
//         totalGoal,
//       };
//     });

//     return groupedWithTotals;
//   };

//   const handleOpenModal = (type, row = null) => {
//     setModalType(type);
//     setFormData(
//       type === "edit" && row
//         ? row
//         : {
//             studentId: slug,
//             assdate: "",
//             coursetest: "",
//             score: 0,
//             goal: 0,
//             type: "sat",
//           }
//     );
//     setShowModal(true);
//   };

//   const handleCloseModal = () => setShowModal(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSave = async () => {
//     try {
//       if (modalType === "edit") {
//         console.log("if", formData);
//         await updateData(formData);
//       } else {
//         console.log("else", formData);
//         await addData(formData);
//       }
//       GetData()
//       handleCloseModal();
//     } catch (error) {
//       console.error("Error saving data:", error);
//       alert("An error occurred while saving the data.");
//     }
//   };

//   const handleDelete = async (id) => {
//     const choice = window.confirm("Are You Sure?");
//     if (choice) {
//       try {
//         await deleteIdData(id);
//         GetData()
//       } catch (error) {
//         console.error("Error deleting data:", error);
//         alert("An error occurred while deleting the data.");
//       }
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <Card className="shadow-lg">
//         <Card.Body>
//           <Card.Title className="text-center text-primary fw-bold">📊 Score Table</Card.Title>

//           <Table hover responsive className="mt-3">
//             <thead className="bg-light">
//               <tr>
//                 <th>Date</th>
//                 <th>Test</th>
//                 <th className="text-center">Score</th>
//                 <th className="text-center text-danger">Goal</th>
//                 {!isProfile && (
//                 <th className="text-end">Actions</th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((row) => (
//                 <tr key={row.id}>
//                   <td>{row.date}</td>
//                   <td>{row.test}</td>
//                   <td className="text-center">{row.score}</td>
//                   <td className="text-center text-danger fw-bold">{row.goal}</td>
//                   {!isProfile && (
//                   <td className="text-end">
//                     <Button variant="success" size="sm" onClick={() => handleOpenModal("edit", row)}>
//                       Update
//                     </Button>{" "}
//                     <Button variant="danger" size="sm" onClick={() => handleDelete(row.id)}>
//                       Delete
//                     </Button>
//                   </td>
//                   )}
//                 </tr>
//               ))}
//               <tr className="fw-bold bg-light">
//                 <td colSpan={2} className="text-end">Total:</td>
//                 <td className="text-center">{totalScore}</td>
//                 <td className="text-center text-danger">{totalGoal}</td>
//                 <td></td>
//               </tr>
//             </tbody>
//           </Table>
//           {!isProfile && (
//           <div className="d-flex justify-content-end">
//             <Button variant="info" size="sm" onClick={() => handleOpenModal("add")}>
//               ➕ Add New Score
//             </Button>
//           </div>
//           )}
//         </Card.Body>
//       </Card>

//       <ScoreModal
//         show={showModal}
//         handleClose={handleCloseModal}
//         handleChange={handleChange}
//         handleSave={handleSave}
//         formData={formData}
//         modalType={modalType}
//       />
//     </div>
//   );
// };

// export default ScoreTable;
import React, { useState, useEffect } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import style from "./academicAssessment.module.css";
import {
  addData,
  deleteIdData,
  getAllData,
  getDataWithType,
  updateData,
} from "../../../../../lib/studentassesment";
import ScoreModal from "./ScoreModal";
import { COURSE_TYPES } from "../academicAssessment";

const ScoreTable = ({ slug, isProfile = false }) => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [formData, setFormData] = useState({
    id: null,
    studentId: slug,
    assdate: "",
    coursetest: "",
    score: "",
    goal: "",
    grade: null,
    type: COURSE_TYPES.sat,
  });

    async function GetData() {
      getDataWithType("sat").then(setData);
    }
  
    useEffect(() => {
      GetData();
    }, [slug]);

  // Veri sıralama ve gruplama fonksiyonu
  const groupedData = () => {
    // Veriyi tarihe göre sıralıyoruz
    const sortedData = [...data]
    .filter(row => row.studentId === slug)
    .sort(
      (a, b) => new Date(a.assdate) - new Date(b.assdate)
    );

    // Aynı tarihe sahip verileri grupla
    const groups = [];
    let currentDate = null;
    let currentGroup = [];

    sortedData.forEach((row) => {
      if (row.assdate !== currentDate) {
        if (currentGroup.length > 0) {
          groups.push(currentGroup);
        }
        currentDate = row.assdate;
        currentGroup = [row];
      } else {
        currentGroup.push(row);
      }
    });

    if (currentGroup.length > 0) {
      groups.push(currentGroup);
    }

    // Grupların altında toplamları hesapla
    const groupedWithTotals = groups.map((group) => {
      const totalScore = group.reduce((acc, row) => acc + row.score, 0);
      const totalGoal = group.reduce((acc, row) => acc + row.goal, 0);

      return {
        date: group[0].assdate, // Tüm grup aynı tarihe ait olacak
        rows: group,
        totalScore,
        totalGoal,
      };
    });

    return groupedWithTotals;
  };

  const handleOpenModal = (type, row = null) => {
    setModalType(type);
    setFormData(
      type === "edit" && row
        ? row
        : {
            studentId: slug,
            assdate: "",
            coursetest: "",
            score: 0,
            goal: 0,
            type: "sat",
          }
    );
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (modalType === "edit") {
        console.log("if", formData);
        await updateData(formData);
      } else {
        console.log("else", formData);
        await addData(formData);
      }
      GetData()
      handleCloseModal();
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving the data.");
    }
  };

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      try {
        await deleteIdData(id);
        GetData()
      } catch (error) {
        console.error("Error deleting data:", error);
        alert("An error occurred while deleting the data.");
      }
    }
  };

  return (
    <div className={`${style.SAT_container} container`}>
      <Card className={`${style.card} ${style.SAT_card} shadow-lg`}>
        <Card.Body className={`${style.cardBody}`}>
        {!isProfile ? (
          <div className="d-flex justify-content-between align-items-center">
            <Card.Title className="text-center text-primary fw-bold">📊 SAT</Card.Title>
            <Button
              variant="info"
              size="sm"
              onClick={() => handleOpenModal("add")}
            >
              ➕ Add New Score
            </Button> 
          </div>
          ):(
            <Card.Title className="text-center text-primary fw-bold">📊 SAT</Card.Title>
          )}
          <div
            className={`${style.tableContainer} ${style.SAT_table_container}`}
          >
            <Table hover responsive className={`${style.SAT_table} mt-3`}>
              <thead className="bg-light">
                <tr>
                  <th>Date</th>
                  <th>Test</th>
                  <th className="text-center">Score</th>
                  <th className="text-center text-danger">Goal</th>
                  {!isProfile && (
                  <th className="text-end">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {groupedData().map((group, idx) => (
                  <React.Fragment key={idx}>
                    {group.rows.map((row) => (
                      <tr key={row.id}>
                        <td>{row.assdate}</td>
                        <td>{row.coursetest}</td>
                        <td className="text-center">{row.score}</td>
                        <td className="text-center text-danger fw-bold">
                          {row.goal}
                        </td>
                        {!isProfile && (
                        <td className="text-end">
                          <Button
                            variant="outline-success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleOpenModal("edit", row)}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDelete(row.id)}
                          >
                            <FaTrash />
                          </Button>
                        </td>
                        )}
                      </tr>
                    ))}
                    <tr>
                      <td className="fw-bold">{group.date}</td>
                      <td className="fw-bold">TOTAL</td>
                      <td className="text-center">{group.totalScore}</td>
                      <td className="text-center text-danger fw-bold">
                        {group.totalGoal}
                      </td>
                      <td></td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <ScoreModal
        show={showModal}
        handleClose={handleCloseModal}
        handleChange={handleChange}
        handleSave={handleSave}
        formData={formData}
        modalType={modalType}
      />
    </div>
  );
};

export default ScoreTable;